
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/Best-gesthouses-Tunisia",
      function () {
        return require("private-next-pages/blog/Best-gesthouses-Tunisia/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/Best-gesthouses-Tunisia"])
      });
    }
  